<template>
    <transition name="buzz-sidenav-slide">
        <aside class="buzz-sidenav">
            <div class="buzz-sidenav-top"></div>
            <div class="buzz-sidenav-header" v-if="isConfig">
                <button class="buzz-sidenav-back" @click="goOverview">← Go back to Overview</button>
            </div>

            <nav class="buzz-sidenav-links">
                <template v-if="isConfig && props.role === 'admin'">
                    <div class="buzz-config-title">Configuration</div>
                    <router-link to="/admin/config/merchant" class="buzz-sidenav-link" active-class="active" exact-active-class="active"><i class="fas fa-store"></i> Merchant Configuration</router-link>
                    <router-link to="/admin/config/widget" class="buzz-sidenav-link" active-class="active" exact-active-class="active"><i class="fas fa-puzzle-piece"></i> Widget Configuration</router-link>
                    <router-link to="/admin/config/payment" class="buzz-sidenav-link" active-class="active" exact-active-class="active"><i class="fas fa-credit-card"></i> Payment Configuration</router-link>
                    <router-link to="/admin/config/bookingconfig" class="buzz-sidenav-link" active-class="active" exact-active-class="active"><i class="fas fa-cogs"></i> Booking Configuration</router-link>
                </template>
                <template v-else-if="props.role === 'admin'">
                    <router-link to="/admin/dashboard" class="buzz-sidenav-link" active-class="active" exact-active-class="active"><i class="fas fa-tachometer-alt"></i>Overview</router-link>
                    <router-link to="/admin/staff/" class="buzz-sidenav-link" active-class="active" exact-active-class="active"><i class="fas fa-users"></i>Staff</router-link>
                    <router-link to="/admin/services" class="buzz-sidenav-link" active-class="active" exact-active-class="active"><i class="fas fa-briefcase"></i> Services</router-link>
                    <router-link to="/admin/hours" class="buzz-sidenav-link" active-class="active" exact-active-class="active"><i class="fas fa-clock"></i> Opening Hours</router-link>
                    <router-link to="/admin/customers" class="buzz-sidenav-link" active-class="active" exact-active-class="active"><i class="fas fa-user-friends"></i> Customers</router-link>
                    <router-link to="/admin/calendar" class="buzz-sidenav-link" active-class="active" exact-active-class="active"><i class="fas fa-calendar-alt"></i> Calendar</router-link>
                    <router-link to="/admin/bookings" class="buzz-sidenav-link" active-class="active" exact-active-class="active"><i class="fas fa-calendar-check"></i> Bookings</router-link>
                    <router-link to="/admin/analytics" class="buzz-sidenav-link" active-class="active" exact-active-class="active"><i class="fas fa-chart-bar"></i> Analytics</router-link>
                </template>
                <template v-else-if="props.role === 'staff'">
                    <router-link to="/staff/dashboard" class="buzz-sidenav-link" active-class="active" exact-active-class="active"><i class="fas fa-tachometer-alt"></i>Overview</router-link>
                    <router-link to="/staff/staff" class="buzz-sidenav-link" active-class="active" exact-active-class="active"><i class="fas fa-users"></i>Staff</router-link>
                    <router-link to="/staff/services" class="buzz-sidenav-link" active-class="active" exact-active-class="active"><i class="fas fa-briefcase"></i> Services</router-link>
                    <router-link to="/staff/customers" class="buzz-sidenav-link" active-class="active" exact-active-class="active"><i class="fas fa-user-friends"></i> Customers</router-link>
                    <router-link to="/staff/calendar" class="buzz-sidenav-link" active-class="active" exact-active-class="active"><i class="fas fa-calendar-alt"></i> Calendar</router-link>
                    <router-link to="/staff/bookings" class="buzz-sidenav-link" active-class="active" exact-active-class="active"><i class="fas fa-calendar-check"></i> Bookings</router-link>
                </template>
            </nav>
        </aside>
    </transition>
</template>

<script setup>
import { useRoute, useRouter } from 'vue-router'
import { computed, defineProps } from 'vue'

const props = defineProps({
    role: {
        type: String,
        required: true
    }
})

const route = useRoute()
const router = useRouter()
const isConfig = computed(() => route.path && (route.path.startsWith('/admin/config') || route.path.startsWith('/staff/config')))

function goOverview() {
    if (props.role === 'admin') {
        router.push('/admin/dashboard')
    } else if (props.role === 'staff') {
        router.push('/staff/dashboard')
    }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Sansita:wght@700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Rubik:wght@400;700&display=swap');

.buzz-sidenav {
    position: fixed;
    top: 0;
    left: 0;
    width: 175px;
    height: 100vh;
    background: #243654;
    box-shadow: 4px 0 24px rgba(36, 54, 84, 0.18), 2px 0 6px rgba(36, 54, 84, 0.1);
    display: flex;
    flex-direction: column;
    z-index: 100;
    will-change: transform;
}

.buzz-sidenav-slide-enter-active,
.buzz-sidenav-slide-leave-active {
    transition: transform 0.35s cubic-bezier(.4, 2, .6, 1), opacity 0.2s;
}

.buzz-sidenav-slide-enter-from,
.buzz-sidenav-slide-leave-to {
    transform: translateX(-100%);
    opacity: 0;
}

.buzz-sidenav-slide-enter-to,
.buzz-sidenav-slide-leave-from {
    transform: translateX(0);
    opacity: 1;
}

.buzz-sidenav-top {
    height: 72px;
    background: rgba(0, 0, 0, 0.12);
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.buzz-sidenav-links {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 12px;
}

.buzz-sidenav-header {
    padding: 12px 16px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.buzz-sidenav-header-title {
    font-size: 16px;
    margin: 0;
    color: #333;
    font-weight: 600;
}

.buzz-sidenav-back {
    background: none;
    border: none;
    color: rgba(255, 255, 255, 0.6);
    text-align: left;
    padding: 6px 0;
    cursor: pointer;
    font-size: 13px;
    transition: color 0.15s;
}

.buzz-sidenav-back:hover {
    color: #fff;
}

.buzz-config-title {
    font-size: 0.68rem;
    font-weight: 600;
    color: rgba(255, 255, 255, 0.4);
    padding: 6px 16px;
    text-transform: uppercase;
    letter-spacing: 0.08em;
}

.buzz-sidenav-link {
    font-family: 'Rubik', sans-serif;
    color: rgba(255, 255, 255, 0.72);
    text-decoration: none;
    font-size: 0.875rem;
    padding: 10px 16px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    gap: 10px;
    transition: background 0.15s, color 0.15s;
    margin: 0 6px;
}

.buzz-sidenav-link.active,
.buzz-sidenav-link:hover {
    background: rgba(255, 255, 255, 0.1);
    color: #fff;
}

.buzz-sidenav-link.active {
    background: rgba(255, 255, 255, 0.15);
    font-weight: 600;
}

.buzz-sidenav-link i {
    font-size: 14px;
    opacity: 0.85;
}
</style>
